(() => {
  'use strict';
  const log = (level, operation, context = {}) => {
    const entry = {timestamp: new Date().toISOString(), level, module: 'mms-store.js', operation, ...context};
    (level === 'ERROR' ? console.error : console.info)(entry);
  };
  document.querySelectorAll('.category-chips:not(.scoped-categories) a').forEach(link => {
    if (new URL(link.href).pathname === location.pathname) link.setAttribute('aria-current', 'page');
  });
  document.querySelectorAll('.collection-toolbar').forEach(form => {
    const select = form.querySelector('[name="sort_by"]');
    if (!select) return;
    let navigating = false;
    const navigate = (replace = false) => {
      if (navigating) return;
      navigating = true;
      form.querySelectorAll('button').forEach(button => { button.disabled = true; });
      const url = new URL(location.href);
      url.searchParams.set('sort_by', select.value);
      // Restart the newly sorted results, retaining the current collection,
      // tag path, budget category and any Shopify storefront filters.
      [...url.searchParams.keys()].forEach(key => {
        if (key === 'page' || key === 'gift_page' || key.startsWith('page_')) url.searchParams.delete(key);
      });
      url.hash = 'sort-by';
      log('INFO', 'COLLECTION_SORT', {sort: select.value, path: url.pathname});
      if (replace) location.replace(url.href);
      else location.assign(url.href);
    };
    select.addEventListener('change', () => navigate());
    form.addEventListener('submit', event => { event.preventDefault(); navigate(); });
    // Old shared URLs can still contain Shopify's ineffective relevance mode.
    if (new URL(location.href).searchParams.get('sort_by') === 'most-relevant') {
      select.value = 'created-descending';
      navigate(true);
    }
  });
  document.querySelectorAll('[data-product-form]').forEach(form => {
    const variant = form.querySelector('[name=id]');
    const price = document.querySelector('[data-variant-price]');
    variant?.addEventListener('change', () => {
      const option = variant.selectedOptions[0];
      if (price && window.MMSPrice) window.MMSPrice.updateElement(price, option.value);
      else if (price) price.textContent = option.dataset.price;
      const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState(null, '', url);
    });
    const upload = form.querySelector('[data-photo-upload]');
    const preview = form.querySelector('.photo-selected');
    const feedback = form.querySelector('.form-feedback');
    const submitButton = form.querySelector('button[type=submit]');
    const idleSubmitLabel = submitButton.textContent;
    const initiallyDisabled = submitButton.disabled;
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      form.dataset.submitting = 'false';
      form.removeAttribute('aria-busy');
      submitButton.textContent = idleSubmitLabel;
      submitButton.disabled = initiallyDisabled;
      variant?.dispatchEvent(new Event('change', {bubbles: true}));
      if (upload?.files.length) upload.dispatchEvent(new Event('change', {bubbles: true}));
    });
    let photoUrl = null;
    upload?.addEventListener('change', () => {
      upload.setCustomValidity(''); feedback.textContent = ''; preview.hidden = true;
      if (photoUrl) { URL.revokeObjectURL(photoUrl); photoUrl = null; }
      const file = upload.files[0]; if (!file) return;
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
        upload.value = ''; upload.setCustomValidity('Choose a JPG, PNG or WebP photo up to 10 MB.'); upload.reportValidity();
        feedback.textContent = 'Please choose a JPG, PNG or WebP photo up to 10 MB.'; return;
      }
      photoUrl = URL.createObjectURL(file); preview.querySelector('img').src = photoUrl; preview.hidden = false;
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity() || form.dataset.submitting === 'true') return;
      const submit = form.querySelector('button[type=submit]'); const original = submit.textContent;
      const hasPhoto = [...form.querySelectorAll('input[type=file]')].some(input => input.files.length > 0);
      form.dataset.submitting = 'true'; form.setAttribute('aria-busy', 'true'); submit.disabled = true; submit.textContent = hasPhoto ? 'Uploading & adding…' : 'Adding…'; feedback.textContent = '';
      const start = performance.now();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {method:'POST', body: new FormData(form), headers:{Accept:'application/json'}});
        const data = await response.json();
        log('INFO', 'CART_ADD', {status:response.status, elapsed_ms:Math.round(performance.now()-start), personalized:!!form.querySelector('[name="properties[_mms_workflow]"]'), hasPhoto});
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'This item could not be added. Please check your options.');
        location.assign(`${root}cart`);
      } catch (error) {
        log('ERROR','CART_ADD_FAILED',{stack:error.stack, trigger:'product form submission'});
        feedback.textContent = `${error.message} Please check your bag before trying again, or contact the studio.`;
        submit.disabled = false; submit.textContent = original; form.dataset.submitting = 'false'; form.removeAttribute('aria-busy');
      }
    });
  });
})();
